export class HarCreator {
    name: string;
    version: string;

    constructor() {
      this.name = 'GODH Client Logger';
      this.version = '1.0';
    }
}
